module.exports = __webpack_public_path__ + "media/images/meta/bft/favicon-90d23b1e9a0703f624efb3d527c4163f.png";